import { getErrorMessage } from "@/core/api/helpers"
import { useAppDispatch } from "@/redux/hooks"
import { useEditEmailAddressMutation } from "@/redux/services/sendersApi"
import { setToast } from "@/redux/toastSlice"
import type { EditEmailAddressPayload } from "@/types/entities/email-address"

export const useEditEmailAddress = () => {
  const dispatch = useAppDispatch()
  const [editEmailAddress, response] = useEditEmailAddressMutation()

  const handleEditEmailAddress = async ({
    body,
    id,
  }: {
    body: EditEmailAddressPayload
    id: string
  }) => {
    try {
      const response = await editEmailAddress({ body, id }).unwrap()
      if (response) {
        dispatch(
          setToast({
            show: true,
            variant: "success",
            message: "Success edit email address",
          }),
        )
      }
      return response
    } catch (error: any) {
      const message = getErrorMessage(error)
      dispatch(
        setToast({
          show: true,
          variant: "error",
          message,
        }),
      )
      throw new Error(message)
    }
  }

  return { editEmailAddress: handleEditEmailAddress, response }
}
